// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};
	

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


	//Accordion
	let accordionItems = document.querySelectorAll('.accordion__item');
    let i;
    for (i = 0; i < accordionItems.length; i++) {
        let disItem = accordionItems[i];
        let disBtn = disItem.querySelector('.accordion__btn');
        disBtn.addEventListener('click', function () {
            disItem.classList.toggle('open');
        });
	}

	//email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		}) 
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
		this.parentElement.classList.add('moved');
		})

	}
	//CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
		for(let j = 0; j < allffields.length; j++){
			
			if(allffields[j].getElementsByTagName('input').length > 0){
				if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
					allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
						this.parentElement.classList.add('moved');
					})
				}
			}
			if(allffields[j].getElementsByTagName('select').length > 0){
				allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
					this.parentElement.classList.add('moved');
				})
			}
			if(allffields[j].getElementsByTagName('textarea').length > 0){
				allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
					this.parentElement.classList.add('moved');
				})
			}
		}
	}


	//Validation footer for padding top if it has slider inmersive quad
	let footer = document.querySelector('#footer_main');
	// find all section and verify if the last item has slider
	let main = document.querySelectorAll('#content section');
	let mainLenght = main.length-1;

	main.forEach((section,position) => {
		//verify the last quad if it has slider
		if(position == mainLenght){
			if (section.classList.contains('js-slider-inmersive')){
				footer.classList.add('js-footer-hight-slider');
			}
		}
	})


	//Custom gallery
	const customLightboxFooter = new LBX(".js-my-lightbox", {
        fullScreen:true,
    });



	// MENU Mobile
	let buttonMobile = document.getElementById('burgerMenu');
	if(buttonMobile != null){
	buttonMobile.addEventListener('click', function () {
			if (!this.classList.contains('open')) {
				this.parentElement.classList.add('open');
				this.classList.add('open');
				document.querySelector(".overlay").classList.add("open");
				document.getElementById("secondary-menu-header").classList.remove("hidden");
			}
			 else {
				this.classList.remove('open');
				let button = document.getElementById("Close").parentElement.parentElement;
				button.removeChild();
				this.parentElement.classList.remove('open');
				document.querySelector(".overlay").classList.remove("open");
			}
		});
		//close btn mobile
		let closeBtn = document.querySelectorAll(".nav-container")[0];
		if(closeBtn){
			let newButton = closeBtn.childNodes[1];
			if (newButton != undefined) {
				if (closeBtn.childNodes[1].classList.contains("mobile")) {
					let generalbutton = closeBtn.childNodes[1].children[0].children[0];
					generalbutton.addEventListener('click', function () {
						document.getElementById("secondary-menu-header").classList.add("hidden");
						document.querySelectorAll('.overlay')[0].classList.remove('open');
						document.getElementById('burgerMenu').classList.remove('open');
					})
				}
			}
		}

	}

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}